import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import FilledInfoCard from "reusables/Cards/InfoCards/FilledInfoCard";
import SectionLayout from "reusables/layouts/SectionLayout";

function ServicesSection({ title, description, data, color }) {
  const renderData = data.map(({ title: groupTitle, description: groupDesc, items }) => (
    <Grid container spacing={3} key={groupTitle} sx={{ mb: 5 }}>
      <Grid item xs={12} lg={2}>
        <MKBox position="sticky" top="100px" pb={1}>
          <MKTypography
            variant="h3"
            color={color}
            fontWeight="bold"
            mb={1}
            sx={{ fontSize: "1.5rem" }}
          >
            {groupTitle}
          </MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="secondary" mb={1} pr={2}>
            {groupDesc}
          </MKTypography>
        </MKBox>
      </Grid>
      <Grid item xs={12} lg={10}>
        <Grid container spacing={3}>
          {items.map(({ name, description: itemDesc, route }) => (
            <Grid item xs={12} md={6} sx={{ mb: 2, display: "flex" }} key={name}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  flex: 1,
                  width: "100%",
                }}
              >
                <FilledInfoCard
                  color={color}
                  icon="verified"
                  title={name}
                  description={itemDesc}
                  action={{ type: "internal", route, label: "See Details" }}
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    wordSpacing: "3px",
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return <SectionLayout title={title} description={description} contents={renderData} />;
}

ServicesSection.defaultProps = {
  color: "info",
};

ServicesSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  color: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          description: PropTypes.string,
          route: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default ServicesSection;
